import ComplaintsPolicy from "../components/SupportCenter/ComplaintsPolicy"
import Support from "../components/SupportCenter/Support"
import SupportHeader from "../components/SupportCenter/SupportHeader"

const SupportCenter = () => {
  return (
    <>
    <SupportHeader/>
    <ComplaintsPolicy/>
    <Support/>
    </>
  )
}

export default SupportCenter